/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_FemaleInputs */

const en_settings_voice_female = /** @type {(inputs: Settings_Voice_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

const es_settings_voice_female = /** @type {(inputs: Settings_Voice_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femenino`)
};

/**
* | output |
* | --- |
* | "Female" |
*
* @param {Settings_Voice_FemaleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_female = /** @type {((inputs?: Settings_Voice_FemaleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_FemaleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_female(inputs)
	return en_settings_voice_female(inputs)
});